import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

function getPlatformHostname() {
  const explicit = (process.env.REACT_APP_PLATFORM_HOST || "").trim().toLowerCase();
  if (explicit) return explicit;
  try {
    const raw = process.env.REACT_APP_BACKEND_URL || (typeof window !== "undefined" ? window.location.origin : "");
    return new URL(raw).hostname.toLowerCase();
  } catch {
    return "";
  }
}

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("access_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  if (cfg.data instanceof FormData) {
    delete cfg.headers["Content-Type"];
  }
  if (typeof window !== "undefined" && cfg.url?.startsWith("/public")) {
    const host = window.location.hostname.toLowerCase();
    const local = new Set(["localhost", "127.0.0.1", "::1"]);
    const platform = getPlatformHostname();
    if (host && !local.has(host) && platform && host !== platform) {
      cfg.headers["X-Public-Host"] = host;
    }
  }
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (
      error.response?.status === 401 &&
      !original._retry &&
      original.url !== "/auth/refresh" &&
      original.url !== "/auth/login" &&
      localStorage.getItem("refresh_token")
    ) {
      original._retry = true;
      try {
        refreshing =
          refreshing ||
          axios.post(`${API}/auth/refresh`, {
            refresh_token: localStorage.getItem("refresh_token"),
          });
        const { data } = await refreshing;
        refreshing = null;
        localStorage.setItem("access_token", data.access_token);
        original.headers.Authorization = `Bearer ${data.access_token}`;
        return api(original);
      } catch (e) {
        refreshing = null;
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
      }
    }
    return Promise.reject(error);
  }
);

export default api;

export function formatError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => e?.msg || JSON.stringify(e)).join(", ");
  return String(detail);
}
